import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import PhotoSwipeDynamicCaption from "photoswipe-dynamic-caption-plugin";
import  'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css'

/**
 * Creates a lightbox with photoswiper npm
 * @param {Element} element
 */
export function createLightbox(element) {
    const leftArrowSVGString = `
        <button class="js--swiper-custom-button-prev hidden md:block group absolute top-1/2 left-5 -translate-y-1/2 w-swiper-button h-swiper-button 
        text-primary border-2 border-primary cursor-pointer hover:text-white transition-colors disabled:opacity-50 disabled:pointer-events-none">
            <div class="absolute top-0 right-0 h-full w-swiper-button-fill group-hover:w-full transition-all duration-150 bg-primary"></div>
            <svg width="14" height="28" class="absolute top-1/2 left-5 -translate-y-1/2 translate-x-0">
                <use href=\"#icon-swiper-chevron-left\"/>
            </svg>
        </button>`;
    const rightArrowSVGString = `
        <button class="js--swiper-custom-button-next hidden md:block group absolute top-1/2 right-5 -translate-y-1/2 w-swiper-button h-swiper-button 
        text-primary border-2 border-primary cursor-pointer hover:text-white transition-colors disabled:opacity-50 disabled:pointer-events-none">
            <div class="absolute top-0 left-0 h-full w-swiper-button-fill group-hover:w-full transition-all duration-150 bg-primary"></div>
            <svg width="14" height="28" class="absolute top-1/2 right-5 -translate-y-1/2 translate-x-0 rotate-180">
                <use href="#icon-swiper-chevron-left"/>
            </svg>
        </button>`;
    const lightbox = new PhotoSwipeLightbox({
        gallery: element,
        children: 'a',
        pswpModule: () => import('photoswipe'),
        counter: false,
        zoom: false,
        clickToCloseNonZoomable: false,
        hideArrows: false, // Force arrows to be visible on touch devices
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: rightArrowSVGString,
        padding: { top: 32, bottom: 32, left: 32, right: 32 }
    });

    const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
        captionContent: '.caption',
        type: 'below',
    });

    lightbox.init();
}
